module.exports = __webpack_public_path__ + "static/media/avatar.18fc71d4.svg";